module.exports = __webpack_public_path__ + "static/media/item_41_6.618d1c70.png";